module.exports = "/static/assets/10a6d6ad8a07826fa2cfa3f251619ba2.png";